import CityPageTemplate from "../city-template/CityPageTemplate";
import { escanabaConfig } from "./data";

export default function EscanabaPage() {
  return <CityPageTemplate config={escanabaConfig} />;
}